export const PDF_WIDTH = 2480;
export const PDF_HEIGHT = 3508;

export const MARGIN_LEFT = 120;
export const MARGIN_TOP = 240;
